<template>
  <div>
    <div class="app-header">
      <div>
        Archetype
      </div>
    </div>
    <div class="wrapper">
      <button @click="toggleNew">+ New parallax</button>
      <div class="new-wrapper" @click.self="toggleNew">
        <div class="new-wrapper-inner">
          <p>Create new parallax</p>
          <input type="text" v-model="newPageName" placeholder="Name" @keyup.enter="addPage">
          <br />
          <br />
          <button @click="addPage">+ Make it</button>
        </div>
      </div>
      <br />
      <br />
      <div class="article-wrapper">
        <article v-for="(page, idx) in pages" :key="idx">
          <router-link :to="{ name: 'edit', params: { id: page['.key'] }}"><img :src="page.socialImage"></router-link>
          <div class="details">
            <h1>{{ page.name }}</h1>
            <div v-html="page.description" />
            <p><router-link :to="{ name: 'edit', params: { id: page['.key'] }}">Edit</router-link></p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import {firestore} from '../main'

export default {
  name: 'Index',
  data() {
    return {
      pages: [],
      newPageName: ''
    }
  },
  firestore() {
    return {
      pages: firestore.collection('pages'),
    }
  },
  methods: {
    toggleNew: function() {
      document.body.classList.toggle('show-new')
    },
    addPage: function() {
      this.$firestore.pages.add(
        {
          name: this.newPageName,
          created_at: new Date()
        }
      );
      this.newPageName = '';
    },
    deletePage: function(page) {
      this.$firestore.pages.doc(page['.key']).delete();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img {
  max-width: 100%;
}
.wrapper {
  background: #eee;
  box-sizing: border-box;
  font-family: sans-serif;
  padding: 6rem;
  min-height: calc(100vh - 64px);
}

.article-wrapper {
  max-width: 66rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.new-wrapper {
  background: rgba(200, 200, 200, 0.9);
  font-family: sans-serif;
  display: none;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.new-wrapper-inner {
  background: #eee;
  margin: auto;
  padding: 9rem 10rem 11rem;
  width: 30rem;
}
.show-new .new-wrapper {
  display: flex;
}
article {
  background: #fff;
  width: 22rem;
  margin-bottom: 3rem;
  margin-right: 3rem;
}
.details {
  padding: 0 1rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue